function RugScanAd() {
  return (
    <aside className="relative z-10 px-4 pb-4 sm:px-6 lg:px-8">
      <a
        href="https://rugscan.ai"
        target="_blank"
        rel="noopener noreferrer"
        className="group mx-auto flex max-w-7xl flex-col overflow-hidden rounded-3xl border border-lime-400/25 bg-white/[0.04] shadow-[0_0_48px_rgba(163,230,53,0.08)] backdrop-blur-xl transition-all hover:border-lime-400/50 hover:shadow-[0_0_64px_rgba(163,230,53,0.16)]"
        aria-label="RugScan AI — AI rug detection for Robinhood Chain. Visit RugScan.AI"
      >
        <div className="relative overflow-hidden">
          <img
            src="https://static.lumi.new/87/87867592e1ee9cd6b18305987c02c03d.webp"
            alt="RugScan.AI banner: Don't get rugged. AI rug detection for Robinhood Chain with a 93 Safe risk score covering liquidity, holders, contract, and activity."
            className="h-auto w-full object-cover object-center"
          />
        </div>
        <div className="flex flex-col gap-4 px-5 py-5 sm:flex-row sm:items-center sm:justify-between sm:px-6 sm:py-5">
          <div className="max-w-3xl">
            <p className="font-[Syne] text-lg font-bold tracking-tight text-white sm:text-xl">
              Don&apos;t get rugged
            </p>
            <p className="mt-1.5 text-sm leading-relaxed text-zinc-400">
              AI rug detection for Robinhood Chain. Instant risk score on liquidity, holders, contract, and activity — so you can trade with confidence. Powered by RugScan AI.
            </p>
          </div>
          <span className="inline-flex shrink-0 items-center justify-center rounded-full bg-lime-400 px-5 py-2.5 text-sm font-semibold text-black transition-transform group-hover:scale-[1.03]">
            Scan on RugScan.AI
          </span>
        </div>
      </a>
    </aside>
  )
}

export default RugScanAd
